<span *ngIf="customerLogo" class="logo customer-logo-span">
  <img class="customer-logo" [src]="customerLogo"/>
</span>
